import {
  REQUEST_NOTES_ACTION_TYPES,
  SUBMIT_NOTE_ACTION_TYPES,
  ADD_ATTACHMENT_ACTION_TYPES,
  SUBMIT_NOTE_RESET,
} from '../actions/notes'

const defaultState = {
  notesAreLoading: false,
  notesList: [],
  notesError: null,
  isSuccess: false,
}

const { NOTES_FAILURE, NOTES_REQUEST, NOTES_SUCCESS } = REQUEST_NOTES_ACTION_TYPES

const { SUBMIT_NOTE_FAILURE, SUBMIT_NOTE_REQUEST, SUBMIT_NOTE_SUCCESS } = SUBMIT_NOTE_ACTION_TYPES

const {
  ADD_ATTACHMENT_FAILURE,
  ADD_ATTACHMENT_REQUEST,
  ADD_ATTACHMENT_SUCCESS,
} = ADD_ATTACHMENT_ACTION_TYPES

const notesReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case NOTES_REQUEST: {
      return {
        ...state,
        notesAreLoading: true,
        notesError: null,
        isSuccess: false,
      }
    }
    case NOTES_SUCCESS: {
      const {
        payload: { notes = [] },
      } = action
      return {
        ...state,
        notesAreLoading: false,
        notesList: notes,
        isSuccess: true,
      }
    }
    case NOTES_FAILURE: {
      return {
        ...state,
        notesAreLoading: false,
        notesError: action.error,
        isSuccess: false,
      }
    }
    case SUBMIT_NOTE_REQUEST: {
      return {
        ...state,
        notesError: null,
      }
    }
    case SUBMIT_NOTE_SUCCESS: {
      return {
        ...state,
        notesAreLoading: false,
        notesError: null,
      }
    }
    case SUBMIT_NOTE_FAILURE: {
      return {
        ...state,
        notesAreLoading: false,
        notesError: action.error,
      }
    }
    case SUBMIT_NOTE_RESET: {
      return {
        ...state,
        notesError: null,
        isSuccess: false,
      }
    }
    case ADD_ATTACHMENT_REQUEST: {
      return {
        ...state,
        notesError: null,
      }
    }
    case ADD_ATTACHMENT_FAILURE: {
      return {
        ...state,
        notesAreLoading: false,
        notesError: action.error,
      }
    }
    case ADD_ATTACHMENT_SUCCESS: {
      const { payload } = action
      const documentObject = {
        documentUrl: payload.fileUrl,
        documentName: payload.fileName,
      }
      return {
        ...state,
        notesList: state.notesList.map(note => {
          if (payload.requestData.id === note.id) {
            note.documents = [...note.documents, documentObject]
          }
          return note
        }),
        notesAreLoading: false,
        notesError: null,
      }
    }
    default:
      return state
  }
}

export default notesReducer
